import { useState, useEffect, useRef } from "react";
export default function PortfolioSection() {
  const sectionRef = useRef<HTMLElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) setVisible(true);
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) obs.observe(sectionRef.current);
    return () => obs.disconnect();
  }, []);
  const cards = [{
    img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1710017/img/2214786491_a527aa3f4a.jpg",
    alt: "HVAC Company — Sacramento, CA",
    title: "HVAC Company — Sacramento, CA",
    desc: "Website Design, Local SEO, GBP Optimization",
    result: "187% increase in leads within 6 months",
    delay: "0ms"
  }, {
    img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1710017/img/2221324843_525b893fae.jpg",
    alt: "Plumbing Service — Austin, TX",
    title: "Plumbing Service — Austin, TX",
    desc: "Website Redesign, SEO, Digital Marketing",
    result: "Ranked #1 for 'plumber Austin' on Google Maps",
    delay: "150ms"
  }, {
    img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1710017/img/2266323411_b0f154e117.jpg",
    alt: "Dental Practice — Denver, CO",
    title: "Dental Practice — Denver, CO",
    desc: "Custom Website, SEO, Conversion Optimization",
    result: "94 new patient inquiries in the first 3 months",
    delay: "300ms"
  }];
  return <section ref={sectionRef} style={{
    backgroundColor: "rgb(255, 255, 255)",
    backgroundPosition: "0% 0%",
    backgroundRepeat: "repeat",
    color: "rgb(2, 8, 23)",
    fontFamily: '"DM Sans", sans-serif',
    animation: "none 0s ease 0s 1 normal none running"
  }} className="w-full">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@400;600;700&family=DM+Sans:wght@400;500;600&display=swap');
        @keyframes fade-in-up {
          0% { opacity: 0; transform: translateY(24px); }
          100% { opacity: 1; transform: translateY(0px); }
        }
        .portfolio-card-anim {
          opacity: 0;
          transform: translateY(24px);
          transition: opacity 0.6s ease, transform 0.6s ease;
        }
        .portfolio-card-anim.visible {
          opacity: 1;
          transform: translateY(0px);
        }
      `}</style>

      <div className="md:py-28 py-20" style={{
      paddingTop: undefined,
      paddingBottom: undefined
    }}>
        <div style={{
        paddingTop: "112px",
        paddingBottom: "112px"
      }} className="hidden" />
        <div className="page-container" style={{
        paddingTop: 0,
        paddingBottom: 0
      }}>
          <div style={{
          paddingTop: "112px",
          paddingBottom: "112px"
        }} className="hidden md:block absolute pointer-events-none" />

          <div className="flex flex-col items-center" style={{
          paddingTop: 0
        }}>
            <div className="flex flex-row items-center gap-2 mb-4" style={{
            backgroundColor: "#F1F5F9",
            border: "1px solid #E2E8F0",
            borderRadius: "9999px",
            padding: "6px 12px"
          }}>
              <span style={{
              color: "#64748B",
              display: "flex",
              alignItems: "center"
            }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <rect width="20" height="14" x="2" y="3" rx="2"></rect>
                  <line x1="8" x2="16" y1="21" y2="21"></line>
                  <line x1="12" x2="12" y1="17" y2="21"></line>
                </svg>
              </span>
              <span style={{
              color: "#64748B",
              fontFamily: '"DM Sans", sans-serif',
              fontSize: "13px",
              fontWeight: "500"
            }}>
                Featured Work
              </span>
            </div>

            <h2 style={{
            color: "rgb(30, 41, 59)",
            fontFamily: "Outfit, sans-serif",
            fontSize: "48px",
            fontWeight: "700",
            lineHeight: "48px",
            letterSpacing: "-1.2px",
            border: "0px solid rgb(226, 232, 240)",
            textAlign: "center",
            animation: "none 0s ease 0s 1 normal none running",
            marginBottom: "16px",
            marginTop: "16px"
          }} className="px-4">
              <span style={{
              color: "#1E293B"
            }}>Websites That </span>
              <span style={{
              color: "#2563EB"
            }}>Deliver</span>
              <span> </span>
              <span style={{
              color: "#06B6D4"
            }}>Results</span>
            </h2>

            <p style={{
            color: "rgb(100, 116, 139)",
            fontFamily: '"DM Sans", sans-serif',
            fontSize: "18px",
            fontWeight: "400",
            lineHeight: "29.25px",
            border: "0px solid rgb(226, 232, 240)",
            textAlign: "center",
            animation: "none 0s ease 0s 1 normal none running",
            maxWidth: "520px",
            marginBottom: "48px"
          }}>
              Take a look at some of our recent projects and the measurable impact they&apos;ve had for local businesses like yours.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 w-full">
              {cards.map((card, idx) => <div key={idx} className={`portfolio-card-anim${visible ? " visible" : ""} hover:shadow-xl transition-shadow duration-300`} style={{
              backgroundColor: "#FFFFFF",
              border: "1px solid #E2E8F0",
              borderRadius: "12px",
              overflow: "hidden",
              transitionDelay: card.delay
            }}>
                  <div style={{
                width: "100%",
                height: "215px",
                overflow: "hidden"
              }}>
                    <img src={card.img} alt={card.alt} className="w-full h-full" style={{
                  objectFit: "cover",
                  display: "block"
                }} />
                  </div>

                  <div style={{
                padding: "24px"
              }}>
                    <h3 style={{
                  color: "rgb(30, 41, 59)",
                  fontFamily: "Outfit, sans-serif",
                  fontSize: "16px",
                  fontWeight: "600",
                  lineHeight: "24px",
                  border: "0px solid rgb(226, 232, 240)",
                  animation: "none 0s ease 0s 1 normal none running",
                  marginBottom: "4px"
                }}>
                      {card.title}
                    </h3>

                    <p style={{
                  color: "rgb(100, 116, 139)",
                  fontFamily: '"DM Sans", sans-serif',
                  fontSize: "14px",
                  fontWeight: "400",
                  lineHeight: "20px",
                  border: "0px solid rgb(226, 232, 240)",
                  animation: "none 0s ease 0s 1 normal none running",
                  marginBottom: "16px"
                }}>
                      {card.desc}
                    </p>

                    <div className="flex flex-row items-start" style={{
                  gap: "8px"
                }}>
                      <span style={{
                    color: "oklch(0.596 0.145 163.225)",
                    flexShrink: 0,
                    marginTop: "2px",
                    display: "flex",
                    alignItems: "center"
                  }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                          <path d="M16 7h6v6"></path>
                          <path d="m22 7-8.5 8.5-5-5L2 17"></path>
                        </svg>
                      </span>
                      <p style={{
                    color: "oklch(0.596 0.145 163.225)",
                    fontFamily: '"DM Sans", sans-serif',
                    fontSize: "14px",
                    fontWeight: "600",
                    lineHeight: "20px",
                    border: "0px solid rgb(226, 232, 240)",
                    animation: "none 0s ease 0s 1 normal none running",
                    margin: 0
                  }}>
                        {card.result}
                      </p>
                    </div>
                  </div>
                </div>)}
            </div>

            <div style={{
            marginTop: "48px"
          }}>
              <a href="#" style={{
              fontFamily: '"DM Sans", sans-serif',
              fontSize: "14px",
              fontWeight: "600",
              lineHeight: "20px",
              backgroundImage: "linear-gradient(to right in oklab, rgb(37, 99, 235) 0%, rgb(6, 182, 212) 100%)",
              borderRadius: "3.35544e+07px",
              border: "0px solid rgb(226, 232, 240)",
              padding: "12px 24px",
              textAlign: "center",
              animation: "none 0s ease 0s 1 normal none running",
              color: "#FFFFFF",
              display: "inline-flex",
              alignItems: "center",
              gap: "8px",
              textDecoration: "none",
              transition: "opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1), transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              cursor: "pointer"
            }} className="hover:opacity-90 hover:scale-105">
                View Full Portfolio
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M5 12h14"></path>
                  <path d="m12 5 7 7-7 7"></path>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @media (min-width: 768px) {
          .portfolio-section-inner {
            padding-top: 112px !important;
            padding-bottom: 112px !important;
          }
        }
        @media (max-width: 767px) {
          .portfolio-section-inner {
            padding-top: 80px !important;
            padding-bottom: 80px !important;
          }
        }
      `}</style>
    </section>;
}